<template>
  <div class="timed-loading-screen">
    <AttensiSpinner />

    <div class="timed-loading-screen__text">
      {{ loadingMessage }}
    </div>
  </div>
</template>

<script>
/**
 * @deprecated - use BaseLoading component instead
 */
import AttensiSpinner from './AttensiSpinner.vue'

export default {
  components: {
    AttensiSpinner,
  },
  props: {
    messages: {
      type: Array,
      required: false,
      default: null,
    },
    message: {
      type: String,
      required: true,
    },
    errorPage: {
      type: String,
      required: true,
    },
    originPage: {
      type: String,
      required: true,
    },
    timeInterval: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      index: 0,
      isTimedOut: false,
      loadingMessages: [
        this.$t('loading.GENERIC_LOADING_MESSAGE1'),
        this.$t('loading.GENERIC_LOADING_MESSAGE2'),
        this.$t('loading.GENERIC_LOADING_MESSAGE3'),
        this.$t('loading.GENERIC_LOADING_MESSAGE4'),
        this.$t('loading.GENERIC_LOADING_MESSAGE5'),
      ],
    }
  },
  computed: {
    loadingMessage() {
      return this.loadingMessages[this.index]
    },
  },
  watch: {
    isTimedOut(done) {
      if (done) {
        this.$router.push({
          name: this.errorPage,
          params: {
            origin: this.originPage,
          },
        })
      }
    },
  },
  created() {
    this.loadingMessages = [this.message, ...this.loadingMessages]
    this.startCountDown()
  },
  methods: {
    nextLoadingMessage() {
      this.index++
    },
    startCountDown() {
      const timer = setInterval(() => {
        if (this.index === this.loadingMessages.length - 1) {
          this.isTimedOut = true
          clearInterval(timer)
        }
        this.nextLoadingMessage()
      }, this.timeInterval)
    },
  },
}
</script>

<style lang="scss" scoped>
.timed-loading-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: $spacing-3xs;
  padding-top: 15%;

  &__text {
    font-weight: 700;
    color: $color-text;
  }
}
</style>
